define([
  "jquery",
  "knockout"],
function($, ko) {

  "use strict";

  // Use stopBinding to allow for nested bindings.
  // See http://www.knockmeout.net/2012/05/quick-tip-skip-binding.html for more information.
  ko.bindingHandlers.stopBinding = {
    init: function() {
      return {
        controlsDescendantBindings: true
      };
    }
  };
  ko.virtualElements.allowedBindings.stopBinding = true;

  ko.bindingHandlers.slideVisible = {
    init: function (element, valueAccessor) {
      var value = valueAccessor();
      $(element).toggle(ko.utils.unwrapObservable(value));
    },
    update: function (element, valueAccessor) {
      var value = valueAccessor();
      if (ko.utils.unwrapObservable(value)) {
        $(element).slideDown();
      } else {
        $(element).slideUp();
      }
    }
  };

});
